import React, { useMemo } from "react";
import PropTypes from "prop-types";
import {
  Box,
  CircularProgress,
  Step,
  Stepper,
  useMediaQuery,
} from "@mui/material";

import StepLabelField from "./StepLabelField";
import { useGetApplicationStatusTrackingByApplicationIdQuery } from "apis/ApplicationStatusTracking";

const REVIEWED_APPLICATION_STATUS = "Reviewed";

export const ApplicationApprovalTimelineChart = ({
  applicationId,
  applicationStatus,
  isFireSafety = false,
  isUtilityTunnel = false,
}) => {
  const { data: { data: applicationStatusTrackingData } = {}, isLoading } =
    useGetApplicationStatusTrackingByApplicationIdQuery(
      applicationId,
      {},
      isFireSafety,
      isUtilityTunnel
    );
  const isMobileDevice = useMediaQuery("(max-width: 768px)");
  const updatedApplicationStatusTrackingData = useMemo(
    () =>
      applicationStatusTrackingData?.length
        ? applicationStatus === REVIEWED_APPLICATION_STATUS
          ? [
              ...applicationStatusTrackingData,
              {
                action: 4,
                userName: "Approval Pending...",
              },
            ]
          : applicationStatusTrackingData
        : [],
    [applicationStatusTrackingData, applicationStatus]
  );

  return isLoading ? (
    <div className="pt-3 d-flex justify-content-center">
      <CircularProgress size={30} />
    </div>
  ) : (
    <Box sx={{ width: "100%" }}>
      <Stepper
        activeStep={updatedApplicationStatusTrackingData.length}
        alternativeLabel={!isMobileDevice}
        className="mt-3"
        orientation={isMobileDevice ? "vertical" : "horizontal"}
      >
        {updatedApplicationStatusTrackingData.map((step, index) => (
          <Step key={index}>
            <StepLabelField step={step} />
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

ApplicationApprovalTimelineChart.propTypes = {
  applicationId: PropTypes.number,
  applicationStatus: PropTypes.string,
  isFireSafety: PropTypes.bool,
  isUtilityTunnel: PropTypes.bool,
};
